/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Footer_Upload_PdfInputs */

const en_app_footer_upload_pdf = /** @type {(inputs: App_Footer_Upload_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload PDF`)
};

const es_app_footer_upload_pdf = /** @type {(inputs: App_Footer_Upload_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir PDF`)
};

/**
* | output |
* | --- |
* | "Upload PDF" |
*
* @param {App_Footer_Upload_PdfInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const app_footer_upload_pdf = /** @type {((inputs?: App_Footer_Upload_PdfInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Footer_Upload_PdfInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_app_footer_upload_pdf(inputs)
	return en_app_footer_upload_pdf(inputs)
});